import { useMemo } from 'react';
import { EXPORT_RAW_DATA_FEATURE_FLAG } from '@fiji/common/src/constants';
import { FeatureFlagData } from '@fiji/common/src/types';

interface UseCanViewExportDataParams {
    allFeatureFlags: { data?: FeatureFlagData[] } | undefined;
    canExportData: boolean;
}

/**
 * Determines if export data feature should be visible based on:
 * - Feature flag being enabled
 * - User having data-export permission
 */
function checkCanViewExportData(featureFlags: FeatureFlagData[], canExportData: boolean): boolean {
    const exportFlagEnabled = featureFlags.some(
        (flag) => flag.featureFlagName === EXPORT_RAW_DATA_FEATURE_FLAG && flag.enabled === true
    );

    return exportFlagEnabled && canExportData;
}

/**
 * Hook to determine if the export data feature should be visible.
 * Extracts feature-flag and role-gating logic to reduce component complexity.
 */
export function useCanViewExportData({ allFeatureFlags, canExportData }: UseCanViewExportDataParams): boolean {
    return useMemo(() => {
        const featureFlags = allFeatureFlags?.data ?? [];

        return checkCanViewExportData(featureFlags, canExportData);
    }, [allFeatureFlags, canExportData]);
}
